import {
  getFieldsSpecDiffs,
  getFieldsSpecStatuses,
} from '../fieldSpec/datasourceUpgradeFieldSpecHelper';
import {
  DatasourceUpgradeFieldUtilsDiff,
  DatasourceUpgradeStatusFieldUtils,
} from '../datasourceUpgrade.types';
import {
  getUnreferencedColumnsDiff,
  getUnreferencedColumnsStatuses,
} from './preserveUnreferencedFields/datasourceUpgradePreserveUnreferencedFieldsHelper';
import { Datasource_FieldUtils } from '@/types/api';
import { filterNulls } from '@/utils/filterNulls';

export const getFieldUtilsStatus = ({
  customUtils,
  upgradeVersionUtils,
  currentVersionUtils,
}: {
  customUtils?: Datasource_FieldUtils;
  upgradeVersionUtils?: Datasource_FieldUtils;
  currentVersionUtils?: Datasource_FieldUtils;
}): DatasourceUpgradeStatusFieldUtils => {
  return {
    temporaryFields: getFieldsSpecStatuses({
      customFields: filterNulls(customUtils?.temporaryFields),
      upgradeVersionFields: filterNulls(upgradeVersionUtils?.temporaryFields),
      currentVersionFields: filterNulls(currentVersionUtils?.temporaryFields),
    }),
    unreferencedColumns: getUnreferencedColumnsStatuses({
      customUtils,
      upgradeVersionUtils,
      currentVersionUtils,
    }),
  };
};

export const getFieldUtilsDiff = ({
  status,
  currentUtils,
  upgradeUtils,
  upgradeVersionUtils,
  currentVersionUtils,
  stage,
  tableName,
}: {
  status: DatasourceUpgradeStatusFieldUtils;
  currentUtils?: Datasource_FieldUtils;
  upgradeUtils?: Datasource_FieldUtils;
  upgradeVersionUtils?: Datasource_FieldUtils;
  currentVersionUtils?: Datasource_FieldUtils;
  stage: 'preTransform' | 'silver';
  tableName?: string;
}): DatasourceUpgradeFieldUtilsDiff => {
  const diff: DatasourceUpgradeFieldUtilsDiff = {
    temporaryFields: getFieldsSpecDiffs({
      tableName,
      stage,
      statuses: status.temporaryFields,
      customFields: filterNulls(currentUtils?.temporaryFields),
      upgradeCustomFields: filterNulls(upgradeUtils?.temporaryFields),
      upgradeVersionFields: filterNulls(upgradeVersionUtils?.temporaryFields),
      currentVersionFields: filterNulls(currentVersionUtils?.temporaryFields),
      isTemporary: true,
      upgradeOmitFields: [],
    }),
    unreferencedColumns: getUnreferencedColumnsDiff({
      status,
      currentUtils,
      upgradeUtils,
      upgradeVersionUtils,
      currentVersionUtils,
      stage,
      tableName,
    }),
  };

  return diff;
};
